import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"

function Divider({ className }) {
  return <hr className={cx("divider border-0", className)} />
}

Divider.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default Divider
